module.exports = __webpack_public_path__ + "img/sous-marin.8ce0dc4b.png";